module.exports = __webpack_public_path__ + "static/media/Customer_Discovery.38e7a6b4.jpg";